<!-- 
Panel showing details of a scheduled job.
-->
<template>
  <div>
    <our-loading-indicator v-if="loading" />
    <div v-else>
      <our-data-container>
        <our-data-field label="Type">{{ lookups.jobTypeDescriptions[scheduledJob.type] }}</our-data-field>
        <our-data-field label="Due">{{ scheduledJob.due | longDateTime }}</our-data-field>
        <our-data-field label="Runs every">{{ frequency }}</our-data-field>
        <our-data-field label="Is suspended">{{ scheduledJob.isSuspended | yesNo }}</our-data-field>
      </our-data-container>
      <v-divider />
      <our-data-container>
        <our-data-field label="Last run">{{ scheduledJob.lastRun | longDateTime }}</our-data-field>
        <our-data-field label="Outcome">{{ lookups.scheduledJobStatusDescriptions[scheduledJob.status] }}</our-data-field>
        <our-data-field label="Time taken">{{ scheduledJob.lastRunTimeTaken | timespan }}</our-data-field>
        <our-data-field label="Output">
          <our-multiline-text :text="loaded ? scheduledJob.lastRunDescription : ''"/>
        </our-data-field>
      </our-data-container>
    </div>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/scheduled-jobs/action-types";

export default {
  mixins: [filterMixins, lookupMixins],
  props: {
    scheduledJobId: {
      required: true,
      type: Number
    }
  },
  computed: {
    state() {
      return this.$store.state.scheduledJobs.view;
    },
    loaded() {
      return this.state.loaded;
    },
    scheduledJob() {
      return this.state.data;
    },
    frequency() {
      const f = this.scheduledJob.frequency;
      const fu = this.scheduledJob.frequencyUnit;
      const desc = this.lookups.jobFrequencyUnitDescriptions[fu];
      const unitDesc = desc ? desc.toLowerCase() : fu;
      return `${f} ${unitDesc}${f > 1 ? "s" : ""}`;
    },
    loading() {
      return this.$store.state.scheduledJobs.view.loading;
    }
  },
  watch: {
    scheduledJobId() {
      this.reload();
    },
    loaded() {
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    async reload() {
      await this.$store.dispatch(action.VIEW_REFRESH, this.scheduledJobId);
    }
  }
};
</script>
